// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3BhBS","title":"ClientCherryInfo_title__QEKx8","itemText":"ClientCherryInfo_itemText__3APPz"};